import {useEffect, useState} from 'react'

/**
 * Returns true when the DOM is ready (after hydration on client-side).
 * Returns false during SSR.
 */
export const useDomReady = () => {
  const [isDomReady, setIsDomReady] = useState(false)

  useEffect(() => {
    if (isDomReady) return
    if (typeof window === 'undefined') return

    const onDomReady = () => {
      setIsDomReady(true)
    }

    if (document.readyState === 'complete') {
      onDomReady()
    } else {
      window.addEventListener('load', onDomReady, {once: true})
    }

    return () => {
      window.removeEventListener('load', onDomReady)
    }
  }, [isDomReady])

  return isDomReady
}
